import DefaultModal from "../defaultModal/DefaultModal";
import useWindowDimensions from "../../../../hooks/useWindowDimensions";
import EditSavedPassengerForm from "../../../forms/editSavedPassenger/EditSavedPassengerForm";

function EditSavedPassengerModal({
  showEditPassenger,
  setShowPassenger,
  handleSubmit,
  form,
  setErrors,
}) {
  const { width } = useWindowDimensions();

  return (
    <DefaultModal
      show={width >= 1024 && showEditPassenger}
      setShow={setShowPassenger}
      className="edit-profile"
      width={1016}
      centered
    >
      <EditSavedPassengerForm
        handleSubmit={handleSubmit}
        form={form}
        setErrors={setErrors}
      />
    </DefaultModal>
  );
}

export default EditSavedPassengerModal;
